module.exports = __webpack_public_path__ + "5135f6b69a11785a7560b91adb11bf9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/stripe_gradient_2x.png
// module id = 143
// module chunks = 0 1 2 3 4